'use client';
module.exports = require('../dist/components/Box/Box');
